import { Component, OnDestroy, inject, input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { Subscription } from 'rxjs'
import { IAsset } from 'src/app/core/interfaces/asset.interface'
import { ConfigService } from 'src/app/core/services/config.service'
import { EventService } from 'src/app/core/services/event.service'
import { AssetPricePipe } from 'src/app/core/pipes/asset-price.pipe'
import { GlobalDataService } from 'src/app/core/services/global-data.service'

@Component({
  selector: 'app-details-sticky-header',
  template: `
    <div
      class="detail__sticky-header"
      [style]="styles()">
      <div class="container">
        <h1 class="detail__info-title h5">{{asset().year}} {{asset().make}} {{asset().model}}</h1>
        <div class="data">
          @if(asset().list_price && !asset().is_list_price_hidden) {
            <div class="detail__info-price h5">{{asset() | assetPrice : globalData.selectedCurrency().code}}</div>
          }
          <button mat-stroked-button i18n="@@asset-details.contact-button.label" class="contact-button" (click)="contactClicked()">Contact Sales</button>
          <button mat-icon-button color="primary" i18n-aria-label="@@asset-details.contact-button.aria-label" aria-label="Contact button" class="contact-button-mobile"  (click)="contactClicked()">
            <mat-icon class="material-icons-outlined">mail_outline</mat-icon>
          </button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./details-sticky-header.component.scss'],
  imports: [CommonModule, MatIconModule, MatButtonModule, AssetPricePipe],
})
export class DetailsStickyHeaderComponent implements OnDestroy {
  configService = inject(ConfigService)
  globalData = inject(GlobalDataService)
  private eventSub: Subscription = new Subscription()
  _eventService = inject(EventService)

  isStuck: boolean = false

  asset = input.required<IAsset>()
  styles = input<any>({})

  ngOnDestroy() {
    this.eventSub.unsubscribe()
  }

  contactClicked(): void {
    this._eventService.notify('contactClicked', this.asset())
  }
}
